export default {
      id: "fish-usage",
      viewBox: "0 0 33 15",
      url: __webpack_public_path__ + "img/icons.svg#fish",
      toString: function () {
        return this.url;
      }
    }